"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Documentation = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _file_uploader = _interopRequireDefault(require("./file_uploader"));

var _index = require("./index");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactstrap = require("reactstrap");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Documentation = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Documentation, _React$Component);

  var _super = _createSuper(Documentation);

  function Documentation(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Documentation);
    _this = _super.call(this, props);
    _this.uploadComplete = _this.uploadComplete.bind((0, _assertThisInitialized2["default"])(_this));
    _this.uploadStart = _this.uploadStart.bind((0, _assertThisInitialized2["default"])(_this));
    _this.state = {
      uploading: 0
    };
    return _this;
  }

  (0, _createClass2["default"])(Documentation, [{
    key: "uploadStart",
    value: function uploadStart() {
      this.setState({
        uploading: this.state.uploading + 1
      });
    }
  }, {
    key: "uploadComplete",
    value: function uploadComplete(fileData) {
      this.setState({
        uploading: this.state.uploading - 1
      });
      this.props.onFileUploaded(fileData);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/_react["default"].createElement(_reactstrap.Row, null, /*#__PURE__*/_react["default"].createElement(_reactstrap.Col, null, /*#__PURE__*/_react["default"].createElement("h4", null, "Supporting Documentation"), /*#__PURE__*/_react["default"].createElement(_file_uploader["default"], {
        pdfServiceUrl: this.props.uploadUrl,
        files: this.props.documentation,
        onUploadStart: this.uploadStart,
        onUploadComplete: function onUploadComplete(fileData) {
          return _this2.uploadComplete(fileData);
        },
        fileSizeTotalLimit: _index.MAX_FILE_SIZE,
        crmClient: this.props.crmClient,
        buttonCaption: " Upload"
      })));
    }
  }]);
  return Documentation;
}(_react["default"].Component);

exports.Documentation = Documentation;
Documentation.propTypes = {
  documentation: _propTypes["default"].array,
  uploadUrl: _propTypes["default"].string.isRequired,
  crmClient: _propTypes["default"].func,
  onFileUploaded: _propTypes["default"].func
};
Documentation.defaultProps = {};